/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Status_ConnectingInputs */



/**
* | output |
* | --- |
* | "Connecting" |
*
* @param {Live_Caption_Status_ConnectingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_status_connecting = /** @type {((inputs?: Live_Caption_Status_ConnectingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Status_ConnectingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("De liaison")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbindung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Collegamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подключение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conectando")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("连接")
	if (locale === "ja") return /** @type {LocalizedString} */ ("接続中")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कनेक्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Conectando")
	return /** @type {LocalizedString} */ ("Connecting")
});